module.exports = __webpack_public_path__ + "img/FerryDashboard-dark.47516376.svg";